import { BillingCycleTypes } from '../../domain/invoice';

export interface IAddLicenseRequest {
    MemberID: number;
    ProductID: number;
    CreditCardID: number;
    BillingCycle: BillingCycleTypes;
    AssignToOwner: boolean;
    YardAddon: boolean;
    DesignerName: string;
    DesignerEmail: string;
}

export class AddLicenseRequest implements IAddLicenseRequest {
    MemberID: number;
    ProductID: number;
    CreditCardID: number;
    BillingCycle: BillingCycleTypes;
    AssignToOwner: boolean;
    YardAddon: boolean;
    DesignerName: string;
    DesignerEmail: string;
}
